const values = {
    HOST: 'https://api.alocubatravel.com',
    GET_PRODUCT_ORDER_TRACKER_URL: "{HOST}/anonymous/product-order/{id}/track",
};

export default values;
